import React from 'react';

import classNames from 'classnames/bind';
import style from './Accentuation.scss';
const ctx = classNames.bind(style);

const Accentuation = props => (
  <span className={ctx('accentuation')}>{props.children}</span>
);

export default Accentuation;
